// extracted by mini-css-extract-plugin
export default {"container":"logout_container__nv4D2"};